import { PeoInfoFragment } from 'src/api';

import {
  CompanyInformationFormPeoAdminFields,
  CompanyInformationFormPeoAdminValues,
} from '../types';

export const getInitialValues = (peo: PeoInfoFragment): CompanyInformationFormPeoAdminValues => {
  return {
    [CompanyInformationFormPeoAdminFields.displayName]: peo.displayName,
    [CompanyInformationFormPeoAdminFields.industry]: peo.industry,
    [CompanyInformationFormPeoAdminFields.contactEmail]: peo.contactEmail,
    [CompanyInformationFormPeoAdminFields.contactPhoneNumber]: peo.contactPhoneNumber,
    [CompanyInformationFormPeoAdminFields.taxYearEndDate]: peo.taxYearEndDate,
    [CompanyInformationFormPeoAdminFields.corporateStructure]: peo.corporateStructure,
    [CompanyInformationFormPeoAdminFields.numberOfEmployees]: peo.numberOfEmployees,
    [CompanyInformationFormPeoAdminFields.fein]: peo.fein,
    [CompanyInformationFormPeoAdminFields.defaultDisclaimer]: peo.defaultDisclaimer,
    [CompanyInformationFormPeoAdminFields.logoFile]: peo.logo
      ? { id: peo.logo.id, size: peo.logo.size }
      : null,
    [CompanyInformationFormPeoAdminFields.headquarters]: peo.headquarters,
  };
};
